<template>
    <v-footer dark height="auto" color="blue-grey darken-4">
        <v-layout justify-center row wrap>
            <v-card flat tile class="blue-grey darken-4">
                <v-card-text>
                    <v-btn
                        v-for="(icon, i) in icons" :key="i"
                        class="mx-1 white--text" icon :href="icon.link"
                    >
                        <v-icon size="24px">{{ icon.icon }}</v-icon>
                    </v-btn>
                </v-card-text>

                <v-divider/>

                <v-card-text class="white--text text-xs-center">
                    <a :href="mainLink" target="_blank">
                        <v-img :src="require('@/assets/img/logo_dark.png')" class="mx-auto" width="90"/>
                    </a>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-footer>
</template>

<script>
export default {
    name: 'WFooter',
    data() {
        return {
            mainLink: process.env.VUE_APP_LINK_MAIN,
        }
    },
    computed: {
        icons() {
            let icons = []
            if(process.env.VUE_APP_LINK_FACEBOOK) icons.push({icon: 'fab fa-facebook', link: process.env.VUE_APP_LINK_FACEBOOK})
            if(process.env.VUE_APP_LINK_LINKEDIN) icons.push({icon: 'fab fa-linkedin', link: process.env.VUE_APP_LINK_LINKEDIN})
            if(process.env.VUE_APP_LINK_INSTAGRAM) icons.push({icon: 'fab fa-instagram', link: process.env.VUE_APP_LINK_INSTAGRAM})
            return icons
        }
    }
}
</script>